export default __webpack_public_path__ + "static/media/MUREB.227bb4d6.png";